export const round = (n, d = 3) => Math.round(n * 10 ** d) / 10 ** d;

export function occupiedWidth(r) {
  return round(r.labelWidth * r.columns + r.hGap * (r.columns - 1));
}

export function lateralSlack(r) {
  return round(r.rollWidth - occupiedWidth(r));
}

export function margins(r) {
  const slack = lateralSlack(r);
  const left = r.autoCenter ? round(slack / 2) : r.manualLeftMargin;
  return { left: round(left), right: round(slack - left) };
}

export function verticalPitch(r) {
  return round(r.labelHeight + r.vGap);
}

export function columnOriginX(r, col) {
  return round(margins(r).left + r.offsetX + col * (r.labelWidth + r.hGap));
}

export const mmToDots = (mm, dpi) => Math.round((mm * dpi) / 25.4);
